import TcCoverLoading from 'components/UI/loading/TcCoverLoading';
import TcListPageNoQuery from 'components/UI/TcListPage/TcListPageNoQuery';
import endpointUrls from 'global/Constants/endpointUrls';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import clientModel, { client } from 'global/Models/clientModel';
import { IBackendSearchGeneric, ITableColumn } from 'global/Models/globalModels';
import ApiService from 'global/utils/ApiService';
import { FC, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCustomerUser } from 'redux/reducer/user/getCustomerUser';
import { RootState, store } from 'redux/store';
import { senderClientApi } from 'services/api/senderClient';

interface iOrderClientList {
  setClient: (_client: client) => void;
}

const OrderClientsList: FC<iOrderClientList> = ({ setClient }) => {
  //states
  const [loading, setLoading] = useState<boolean>(false);
  const [list, setList] = useState<IBackendSearchGeneric<client>>();
  const { userProfile, customerUser } = useSelector((state: RootState) => state.user);

  const { handleMakeDefault } = senderClientApi(() => getList());

  //effect
  useEffect(() => {
    userProfile && !customerUser && store.dispatch(getCustomerUser(userProfile.id));
  }, [userProfile]);

  //functions
  const getList = async (values?: Record<string, any>) => {
    setLoading(true);
    await ApiService.post(endpointUrls.clientGetAll, { ...values, customerId: customerUser?.customerId })
      .then((res: IBackendSearchGeneric<client>) => handleApiThenGeneric({ res, notifFail: false, notifSuccess: false, onSuccess: setList }))
      .catch(() => {});
    setLoading(false);
  };
  const columns: ITableColumn[] = useMemo(
    () => [
      ...(clientModel.columns(undefined, undefined, handleMakeDefault) as ITableColumn[]),
      {
        title: 'انتخاب',
        key: 'select',
        dataIndex: 'select',
        render: (_text: string, record: client) => (
          <span
            className='cursor-pointer text-t-secondary-color hover:underline'
            onClick={() => {
              setClient(record);
            }}>
            انتخاب
          </span>
        ),
      },
    ],
    []
  );

  return (
    <div>
      {!customerUser && (
        <div className='relative w-full h-32'>
          <TcCoverLoading />
        </div>
      )}
      {customerUser && (
        <TcListPageNoQuery
          columns={columns}
          getList={getList}
          loading={loading}
          list={list}
          filterItems={clientModel.filterItems}
          moreContent={<div className='pb-2 mb-2 border-b'>لیست</div>}
        />
      )}
    </div>
  );
};

export default OrderClientsList;
